import React from "react";
import "./Home.css";
import Product from "./Product";

function Home() {
  return (
    <div className="home">
      <div className="home_container">
        <img
          className="home_image"
          src={process.env.PUBLIC_URL + "/hero-img.jpg"}
          //   https://images-eu.ssl-images-amazon.com/images/G/02/digital/video/
          //   merch2016/Hero/Covid19/Generic/GWBleedingHero_ENG_COVIDUPDATE__XSite_1500x600_PV_en-GB
          //   ._CB428684220_.jpg
          alt="Home Background"
        />
        <div className="home_row">
          <Product
            id="12321341"
            title="The Lean Startup"
            price={19.99}
            image="https://images-eu.ssl-images-amazon.com/images/I/81j0RhrgNNL.__BG0,0,0,0_FMpng_AC_UL474_SR474,450_.jpg"
            rating={3}
          />
          <Product
            id="49538094"
            title="Kenwood kMix Stand Mixer for Baking, Stylish kitchen Mixer with K-beater, Dough Hook and Whisk, 5 Litre Glass bowl"
            price={239.0}
            rating={4}
            image="https://www.pikpng.com/pngl/m/68-686864_download-kitchenaid-mixer-png-clipart.png"
          />
        </div>
        <div className="home_row">
          <Product
            id="35658094"
            title="Samsung LCNSSBUWUY324NSUB 49'Curved LED Gaming Monitor"
            price={199.99}
            rating={3}
            image="https://images.samsung.com/is/image/samsung/in-led-sf350-ls27f350fhwxxl-001-front-black"
          />
          <Product
            id="12338094"
            title="Amazon Echo (3rd Generation) | Smart Speaker"
            price={98.99}
            rating={4}
            image="https://assets.stickpng.com/images/5871217c38315b0eebc1da26.png"
          />
          <Product
            id="43221494"
            title="New Apple iPad Pro"
            price={598.99}
            rating={5}
            image="https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/ipad-pro-11-select-wifi-spacegray-202003_FMT_WHH?wid=940&hei=1112&fmt=png-alpha&qlt=80&.v=1583546263566"
          />
        </div>
        <div className="home_row">
          <Product
            id="49538056"
            title="Kenwood kMix Stand Mixer for Baking, Stylish kitchen Mixer with K-beater, Dough Hook and Whisk, 5 Litre Glass bowl"
            price={239.0}
            rating={4}
            image="https://images.samsung.com/is/image/samsung/in-led-sf350-ls27f350fhwxxl-001-front-black"
          />
        </div>
      </div>
    </div>
  );
}

export default Home;
